import * as React from 'react';
import * as shortid from 'shortid';
import {styled} from '../../../utils';
import {LayoutHookContextConsumer} from '../Layout';
import {LayoutHooks} from '../types';

const Root = styled('aside')({
  boxSizing: 'border-box',
  flexShrink: 0
});

class HookedSider extends React.Component<LayoutHooks, {}> {
  private _uid = shortid.generate();

  public componentDidMount() {
    if (typeof this.props.registerSider === 'function') {
      this.props.registerSider(this._uid);
    }
  }

  public componentWillUnmount() {
    if (typeof this.props.unregisterSider === 'function') {
      this.props.unregisterSider(this._uid);
    }
  }

  public render() {
    return <Root {...this.props} />;
  }
}

const Sider = (props: React.AllHTMLAttributes<{}>) => (
  <LayoutHookContextConsumer>{hooks => <HookedSider {...props} {...hooks} />}</LayoutHookContextConsumer>
);

export default Sider;



// WEBPACK FOOTER //
// ./src/components/Layout/Sider/Sider.tsx